import { fetcher } from "utils";

export const delete__users__coordi = (id: number | string): Promise<" "> => fetcher.delete(`/users/coordi/${id}`);
